import React from 'react';
import { RTCI_TOUCH_POINT_URL, IPCID_URL, MS_LOCATION } from '../../constants/constants';
import { isNullOrUndefined } from './CommonFunctions';
import {DropdownSelect} from '@vds/selects';

export default class DropDownCallMe extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subTopicsData: {},
            countries: [],
            callPlan: [],
            timeSlots: [],
            selectCallPlan :"",
            selectedDate: "",
            callAPIResponse : {},
            selecttopicValue :""
        }
        this.topicsSelectedIndex = -1;
        this.subTopicsSelectedIndex = -1;
        this.PageHostedLink = "https://www.verizon.com/support/residential/contact-us/callmecontactus.html";
        this.topicsContent = "";
        this.selectedTopicValue = "";
        this.selectedSubTopicValue = "";
        this.callApproximateTime = "";
        this.time = "";
        this.GlobalSessionID = this.props.GID;
        this.makeIPCADCall = false;
        this.splittedDates = [];
        this.splittedTime = [];
        this.AvailableTimeSlots = [];
        this.documentHandler = this.onDocumentClick.bind(this);
        this.DDLData = this.props.DDlData;
        this.timeWithoutMerdian = [];
   
    }
    getCallSchedule() {
        let schedule = ["As soon as agent is available", "Later today"];
        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let todayDate = new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).toJSON().slice(0, 10).replace(/-/g, '/');
        let temp_date = todayDate.split("/");
        let month = "Tomorrow, " + months[Number(temp_date[1]) - 1] + " " + temp_date[2];
        schedule.push(month.toString());
        return schedule;
    }

    getRTCIJSON(IntentCategory, Intent, Topic, SubTopic) {
        let HostURL = window.location.href;
        let index = HostURL.indexOf('vcm');
        HostURL = HostURL.substr(index - 1);
        let RTCIJSON = {
            "annExchange": [{
                "version": "v1",
                "resource": "omnichanneltouchpoints"
            }
            ],
            "header": {
                "requestingsystem": "ESupport",
                "ApplicationId": "ESupport",
                "ChannelId": "PC",
                "ApplicationName": "ESupport",
                "AppServerName": "10.118.1.11",
                "AppServerIP": "10.118.1.11",
                "AppServerTimeStamp": "11/13/19 09:22.57.662",
                "IntentCategory": "Support",
                "Intent": "CONTACT_US",
                "TrackingInfo": {
                    "-TrackingId": "20191113_09:22:54.625_-538844986",
                    "-SessionId": "1253DB04C6AE6B5E444BBBB8434499E2",
                    "-GlobalSessionId": this.GlobalSessionID
                },
                "IntentOutcome": "success"
            },
            "identifier": {
                "Interaction": {
                    "StartTime": "",
                    "InitiationType": "CUSTOMER_INITIATED",
                    "CustomerInfo": {
                        "Type": "Existing",
                        "AuthType": isNullOrUndefined(window.userinfo) ? "0" : "1",
                        "Attribute": [{
                            "-Name": "BTN",
                            "#text": ""
                        }, {
                            "-Name": "PCAN",
                            "#text": ""
                        }, {
                            "-Name": "ACCESS_TYPE",
                            "#text": "NA"
                        }, {
                            "-Name": "IP",
                            "#text": "*****"
                        }
                        ]
                    },
                    "Activity": [{
                        "Category": "Support",
                        "Type": "ESUPPORT",
                        "StartTime": "",
                        "CorrelationInfo": null,
                        "InteractedAsset": {
                            "WebURL": window.location.href,
                            "PageName": "ESUPPORT",
                            "PageId": null,
                            "NavgationPath": HostURL,
                            "AssetId": "ESUPPORT",
                        },
                        "Payload": {
                            "Other": {
                                "FunctionalCategory": {
                                    "DataElements": [{
                                        "Data": null
                                    }
                                    ],
                                    "TransactionStatus": "SUCCESS",
                                    "-Name": Topic
                                },
                                "FunctionalSubCategory": {
                                    "DataElements": [{
                                        "Data": null
                                    }
                                    ],
                                    "TransactionStatus": "SUCCESS",
                                    "-Name": SubTopic
                                }
                            },
                            "-ChannelName": this.getUserAgent()
                        },
                        "Status": "SUCCESS"
                    }
                    ]
                }
            }
        }
        return RTCIJSON;
    }

    componentDidMount() {
        document.addEventListener('click', this.documentHandler, true);
        this.setState({
            countries: [
                {id:'SEL',name :'Select'},
                {id: 'AFG', name: 'Afghanistan'},
                {id: 'ALA', name: 'Aland Islands'},
                {id: 'ALB', name: 'Albania'}
            ]
        });
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.documentHandler, true);
    }

    onDocumentClick(e) {
        if (!e.target.classList.contains('text') && !e.target.classList.contains('ddl-item') && !e.target.classList.contains('submit_button') && !e.target.classList.contains('submit_btn')) {
            this.hideDropdownMenu(e);
        } else if (e.target.classList.contains('text') && document.querySelectorAll('.dropdown.active').length > 0) {
            document.querySelectorAll('.dropdown.active')[0].classList.remove('active');
        }
        if(!isNullOrUndefined(document.querySelector('.keyboard_focus'))) {
            document.querySelector('.keyboard_focus').classList.remove('keyboard_focus');
        }
      //  this.props.ValidateCheckBox(document.querySelector('.custom-phone-input'));
    }

    hideDropdownMenu(e) {
        if (document.querySelector('.dropdown.active') !== null && document.querySelector('.dropdown.active') !== undefined) {
            document.querySelector('.dropdown.active').classList.remove('active');
        }
    }

    makeAPICall(URL, data) {
        let localInstance = this;
        fetch(URL, {
            method: "POST",
            headers: new Headers({
                'content-type': 'application/json'
            }),
            body: JSON.stringify(data)
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
           // json = "";
          //  let jsondata ='{"VZCBResponse":{"Header":{"ClientName":"ESUPPORT","ClientIP":"68.134.166.232","TransactionID":-549845223,"RequestName":"GetCBOptions"},"Body":{"GetCBOptionsResponse":{"GlobalSessionID":"NESmPB%2F%2BuVrOnzSdKMc19VmyRk0%2FqlDohVPwLetwYxjk%2B9uzzgMiRTkDP8vCvNOv5dq","CBType":"PRIORITY","QueueName":"NewCustSales_Online","AvailableSlots":"3/3/2022~10:30~42|3/3/2022~10:45~49|3/3/2022~11:00~49|3/3/2022~11:15~50|3/3/2022~11:30~49|3/3/2022~11:45~50|3/3/2022~14:00~50|3/3/2022~14:15~50|3/3/2022~14:30~50|3/3/2022~14:45~50|3/3/2022~15:00~50|3/3/2022~15:15~50|3/3/2022~15:30~50|3/3/2022~15:45~50|3/3/2022~16:00~50|3/3/2022~16:15~50|3/3/2022~16:30~50|3/3/2022~16:45~50|3/3/2022~17:00~50|3/3/2022~17:15~50|3/3/2022~17:30~50|3/3/2022~17:45~50|3/4/2022~10:30~50|3/4/2022~10:45~50|3/4/2022~11:00~49|3/4/2022~11:15~50|3/4/2022~11:30~49|3/4/2022~11:45~49|3/4/2022~14:00~50|3/4/2022~14:15~50|3/4/2022~14:30~50|3/4/2022~14:45~50|3/4/2022~15:00~50|3/4/2022~15:15~50|3/4/2022~15:30~50|3/4/2022~15:45~50|3/4/2022~16:00~50|3/4/2022~16:15~50|3/4/2022~16:30~50|3/4/2022~16:45~50|3/4/2022~17:00~50|3/4/2022~17:15~50|3/4/2022~17:30~50|3/4/2022~17:45~50|","StatusCode":0,"Description":"Success"}}}}';
          //  json =JSON.parse(json);

            if (json.VZCBResponse !== undefined && json.VZCBResponse !== null) {
                if (document.querySelector('.show_spinner') !== null) {
                    document.querySelector('.show_spinner').classList.remove('show_spinner');
                }
                localInstance.props.EnableConfirmButton();
                if (json.VZCBResponse.Body.GetCBOptionsResponse.AvailableSlots === "") {
                    localInstance.props.ConformCall(localInstance.selectedTopicValue, localInstance.selectedSubTopicValue, localInstance.time, localInstance.GlobalSessionID, "", "NON_PRIORITY");
                   
                } else {
                    let stateValue = localInstance.getCallSchedule();
                    localInstance.AvailableTimeSlots = localInstance.getTimeSlots(json);
                    localInstance.setState({
                        callPlan: stateValue,
                        callAPIResponse : json
                    })
                }
            }
            if (localInstance.makeIPCADCall) {
                localInstance.makeIPCADCall = false;
                localInstance.makeIPACDAPICall();
            }
        }).catch(function (e) {
            if (document.querySelector('.show_spinner') !== null) {
                document.querySelector('.show_spinner').classList.remove('show_spinner');
            }
            localInstance.props.EnableConfirmButton();
          // let strvalue ='{"VZCBResponse":{"Header":{"ClientName":"ESUPPORT","ClientIP":"68.134.166.232","TransactionID":-549845223,"RequestName":"GetCBOptions"},"Body":{"GetCBOptionsResponse":{"GlobalSessionID":"NESmPB%2F%2BuVrOnzSdKMc19VmyRk0%2FqlDohVPwLetwYxjk%2B9uzzgMiRTkDP8vCvNOv5dq","CBType":"PRIORITY","QueueName":"NewCustSales_Online","AvailableSlots":"3/3/2022~10:30~42|3/3/2022~10:45~49|3/3/2022~11:00~49|3/3/2022~11:15~50|3/3/2022~11:30~49|3/3/2022~11:45~50|3/3/2022~14:00~50|3/3/2022~14:15~50|3/3/2022~14:30~50|3/3/2022~14:45~50|3/3/2022~15:00~50|3/3/2022~15:15~50|3/3/2022~15:30~50|3/3/2022~15:45~50|3/3/2022~16:00~50|3/3/2022~16:15~50|3/3/2022~16:30~50|3/3/2022~16:45~50|3/3/2022~17:00~50|3/3/2022~17:15~50|3/3/2022~17:30~50|3/3/2022~17:45~50|3/4/2022~10:30~50|3/4/2022~10:45~50|3/4/2022~11:00~49|3/4/2022~11:15~50|3/4/2022~11:30~49|3/4/2022~11:45~49|3/4/2022~14:00~50|3/4/2022~14:15~50|3/4/2022~14:30~50|3/4/2022~14:45~50|3/4/2022~15:00~50|3/4/2022~15:15~50|3/4/2022~15:30~50|3/4/2022~15:45~50|3/4/2022~16:00~50|3/4/2022~16:15~50|3/4/2022~16:30~50|3/4/2022~16:45~50|3/4/2022~17:00~50|3/4/2022~17:15~50|3/4/2022~17:30~50|3/4/2022~17:45~50|","StatusCode":0,"Description":"Success"}}}}';
          // strvalue =JSON.parse(strvalue);
         //  document.querySelector("#callmeButton").classList.remove('disabled');
            // let stateValue = localInstance.getCallSchedule();
            //         localInstance.AvailableTimeSlots = localInstance.getTimeSlots(strvalue);
            //         localInstance.setState({
            //             callPlan: stateValue,
            //             callAPIResponse : strvalue
            //         })
            console.log('error');
        })
    }

    getCookie(name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";domain=localhost:3000;" + expires + ";path=/;secure;HttpOnly;SameSite=Strict";
    }

    makeIPACDAPICall() {
        let data = {
            "VZCBRequest": {
                "Header": {
                    "ClientName": "ESUPPORT",
                    "ClientIP": "68.134.166.232",
                    "TransactionID": -549845223,
                    "RequestName": "GetCBOptions"
                },
                "Body": {
                    "GetCBOptionsRequest": {
                        "GlobalSessionID": this.GlobalSessionID,
                        "State": "MD",
                        "Language": {},
                        "LOB": 1
                    }
                }
            }
        }
        this.makeAPICall(MS_LOCATION + "/callme/timeslots", data);
       // this.makeAPICall("https://wwwawssit.ebiz.verizon.com/support" + "/callme/timeslots", data);  //Testcode"https://wwwawssit.ebiz.verizon.com/support"
    }

    getUserAgent() {
        let userAgentString = navigator.userAgent;
        let ua = userAgentString.toUpperCase();
        let platform = "PC";
        if ((ua.indexOf("IPHONE") > -1 || ua.indexOf("IPAD") > -1 || ua.indexOf("IPOD") > -1) && ua.indexOf("SAFARI") > -1) {
            platform = "Mobile";
        }
        else if ((ua.indexOf("IPHONE") > -1 || ua.indexOf("IPAD") > -1 || ua.indexOf("IPOD") > -1) && ua.indexOf("SAFARI") == -1) {
            platform = "Mobile";
        }
        else if (ua.indexOf("ANDROID") > -1 && ua.indexOf("VZAPP-ANDROID") > -1) {
            platform = "Mobile";
        }
        else if (ua.indexOf("ANDROID") > -1) {
            platform = "Mobile";
        }
        else {
            platform = "PC";
        }
        return platform;
    }


    postSelectdTopics(e, selectedValue) {
        this.selectedTopicValue = e.target.getAttribute('data-item-value');
        this.makeIPCADCall = false;
        this.setState({
            subTopicsData: this.DDLData[e.target.innerText]
        })
    }

    postSelectedSubTopic(e, selectedValue) {
        this.selectedSubTopicValue = e.target.getAttribute('data-item-value');
        this.makeIPCADCall = true;
        document.querySelector('.hide_spinner').classList.add('show_spinner');
        document.querySelector("#callmeButton").classList.remove('disabled');
        this.makeAPICall(MS_LOCATION + "/constructedtouchpoint", this.getRTCIJSON("Support", "CONTACT_US", this.selectedTopicValue, this.selectedSubTopicValue));
        //https://wwwawssit.ebiz.verizon.com/support
       // this.makeAPICall("https://wwwawssit.ebiz.verizon.com/support" + "/constructedtouchpoint", this.getRTCIJSON("Support", "CONTACT_US", this.selectedTopicValue, this.selectedSubTopicValue));
    }

    onDropDownKeyAction(e) {
        e.preventDefault();
        let Items = "";
        let ddlElement = (e.target.classList.contains('dropdown')) ? e.target : e.target.parentElement;
        let ddlIndex = parseInt(ddlElement.getAttribute('data-item-index'), 10);
        let ddl = document.querySelectorAll('.dropdown');
        if(event.keyCode == 9) {
            if(!isNullOrUndefined(document.querySelector('.keyboard_focus'))) {
                document.querySelector('.keyboard_focus').classList.remove('keyboard_focus');
            }
            if(event.shiftKey) {
                if(isNullOrUndefined(ddl[ddlIndex - 1])) {
                    setTimeout(() => {
                        document.querySelector('.custom-phone-input').focus();
                    }, 100);
                } else {
                    ddl[ddlIndex - 1].focus();
                    ddl[ddlIndex -1].classList.add("keyboard_focus");
                }
            } else {
                if(isNullOrUndefined(ddl[ddlIndex + 1])) {
                    setTimeout(() => {
                        document.querySelector('.submit_button').focus();
                    }, 100);
                } else {
                    ddl[ddlIndex + 1].focus();
                    ddl[ddlIndex + 1].classList.add('keyboard_focus');
                }
            }
        }
        if(e.target.classList.contains('dropdown') && (e.keyCode === 13)) {
            this.showDropdownMenu(e);
        }
        if(e.target.classList.contains('dropdown')) {
        Items = e.target.querySelectorAll('.ddl-item');
            if(e.target.classList.contains('active') && (e.keyCode === 40)) {
                e.target.querySelector('.ddl-item').classList.add('focused');
                console.log("Called");
                e.target.querySelector('.ddl-item').focus();
            }
        } else if(e.target.classList.contains('ddl-item')) {
            Items = e.target.parentElement.querySelectorAll('.ddl-item');
            let focusedItem =e.target.parentElement.querySelector('.ddl-item.focused');
            if(!isNullOrUndefined(focusedItem)) {
                let currentIndex = parseInt(focusedItem.getAttribute('data-item-index'), 10);
                Items[currentIndex].classList.remove('focused');
                if(isNullOrUndefined(Items[currentIndex+1])) {
                    Items[0].focus();
                    Items[0].classList.add('focused');
                } else {
                    Items[currentIndex + 1].focus();
                    Items[currentIndex + 1].classList.add('focused');
                }
            }
        }
        
        if (e.target.classList.contains('ddl-item') && (e.keyCode === 13)) {
            this.onItemSelect(e);
        }
    }


    onItemSelect(e) {
        if (e.target.parentElement.getElementsByClassName('selected').length > 0) {
            e.target.parentElement.getElementsByClassName('selected')[0].classList.remove('selected');
        }
        e.target.classList.add('selected');
        e.target.parentElement.parentElement.querySelector('.text').innerText = e.target.innerText;
        this.topicsSelectedIndex = parseInt(e.target.getAttribute('data-item-index'), 10);
        const selectedValue = e.target.getAttribute('data-item-value');
        e.target.parentElement.parentElement.classList.add('value-selected');
        if (e.target.parentElement.parentElement.classList.contains('ddl1')) {
            this.postSelectdTopics(e, selectedValue);
        }
        if (e.target.parentElement.parentElement.classList.contains('ddl2')) {
            this.postSelectedSubTopic(e, selectedValue);
        }
        if (e.target.parentElement.parentElement.classList.contains('ddl3')) {
            let uniqueDates = [... new Set(this.splittedDates)]
            let selectedDate = this.topicsSelectedIndex === 2 ? uniqueDates[1] : uniqueDates[0]
            let correspondingTimeSlots =  this.getCorrespondingTimeSlots(selectedDate);
            this.setState({ timeSlots: correspondingTimeSlots, selectedDate });
        }
        if (e.target.parentElement.parentElement.classList.contains('ddl4')) {
            const index = this.timeWithoutMerdian.indexOf(e.target.innerText.substring(0, e.target.innerText.indexOf(" ")));
            const meridian = e.target.innerText.substring(e.target.innerText.indexOf(" ") + 1);
            this.time = this.state.selectedDate + " " + this.timeWithoutMerdian[index];
            this.props.ConformCall(this.selectedTopicValue, this.selectedSubTopicValue, this.time, this.GlobalSessionID, meridian, "PRIORITY");
            this.props.EnableConfirmButton();
        }
        if (e.target.parentElement.parentElement.classList.contains('last-ddl')) {
            this.props.EnableConfirmButton();
        }
        this.hideDropdownMenu();
    }

    getCorrespondingTimeSlots = (selectedDate) => {
        let AvailableSlots = this.state.callAPIResponse.VZCBResponse.Body.GetCBOptionsResponse.AvailableSlots;
        let priority = this.state.callAPIResponse.VZCBResponse.Body.GetCBOptionsResponse.CBType;
        this.splittedDates = [];
        this.splittedTime = [];
        if (AvailableSlots !== "" && priority === "PRIORITY") {
            let splittedValue = AvailableSlots.split('|');
            this.splittedTime = splittedValue.filter(item => item.toString().includes(selectedDate)).map((item, index) => {
                this.splittedDates.push(item.slice(0, item.indexOf('~')));
                return item.slice(item.indexOf('~') + 1, item.lastIndexOf('~'));
            })
            return this.convertTimeInTo12HoursFormats(this.splittedTime);
        }
    }

    

    getTimeSlots(response) {
        let AvailableSlots = response.VZCBResponse.Body.GetCBOptionsResponse.AvailableSlots;
        let priority = response.VZCBResponse.Body.GetCBOptionsResponse.CBType;
        this.splittedDates = [];
        this.splittedTime = [];
        if (AvailableSlots !== "" && priority === "PRIORITY") {
            let splittedValue = AvailableSlots.split('|');
            this.splittedTime = splittedValue.map((item, index) => {
                this.splittedDates.push(item.slice(0, item.indexOf('~')));
                return item.slice(item.indexOf('~') + 1, item.lastIndexOf('~'));
            })
            return this.convertTimeInTo12HoursFormats(this.splittedTime);
        }
    }

    convertTimeInTo12HoursFormats(splittedTime) {
        let localInstance = this;
        let localTime = splittedTime.map((item, index) => {
            if (item !== "" && parseFloat(item.substring(0, item.indexOf(":"))) < 12) {
                let time =  item.substring(0, item.indexOf(":")) + item.substring(item.indexOf(":"));
                localInstance.timeWithoutMerdian.push(time);
                return time  + " AM";
            } else if (item !== "") {
                let time = (parseFloat(item.substring(0, item.indexOf(":"))) - 12 === 0) ? "12" : (parseFloat(item.substring(0, item.indexOf(":"))) - 12);
                localInstance.timeWithoutMerdian.push(time + item.substring(item.indexOf(":")));
                return (time + item.substring(item.indexOf(":"))) + " PM";
            }
        })
        return localTime;
    }

    showSubtopicsList(e) {

        let idx = e.target.selectedIndex;
	    let dataset = e.target.options[idx].value
       // this.selectedTopicValue = e.target.getAttribute('data-item-value');
      
       this.setState({
        selecttopicValue: dataset
    })
        this.makeIPCADCall = false;
        this.setState({
            subTopicsData: this.DDLData[dataset]
        })

       
    }

    showshowCallPlanlist(e){
        
        let idx = e.target.selectedIndex;
	    let selectvalue = e.target.options[idx].value
        let topicValue = this.state.selecttopicValue
        this.selectedTopicValue = topicValue
       // this.selectedTopicValue = e.target.getAttribute('data-item-value');
       this.selectedSubTopicValue =selectvalue;
       this.makeIPCADCall = true;  
      // this.props.EnableConfirmButton();    
       document.querySelector('.hide_spinner').classList.add('show_spinner');
        this.makeAPICall(MS_LOCATION+ "/constructedtouchpoint", this.getRTCIJSON("Support", "CONTACT_US", this.selectedTopicValue, this.selectedSubTopicValue));
    }

    showtimeSlotlist(e){
         let idx = e.target.selectedIndex;
	   let selectvalue = e.target.options[idx].value;
        let uniqueDates = [... new Set(this.splittedDates)]
            let selectedDate = this.topicsSelectedIndex === 2 ? uniqueDates[1] : uniqueDates[0]
        let correspondingTimeSlots =  this.getCorrespondingTimeSlots(selectedDate);
        this.setState({ timeSlots: correspondingTimeSlots, selectedDate });
        localStorage.setItem('IsSelectedCallPlan',selectvalue);
    }
    hideDropdownMenu(e) {
        if (document.querySelector('.dropdown.active') !== null && document.querySelector('.dropdown.active') !== undefined) {
            document.querySelector('.dropdown.active').classList.remove('active');
        }
    }
    settimeSlot(e){
        
    }
   

    render() {
        const { countries } = this.state;

	let countriesList = countries.length > 0
		&& countries.map((item, i) => {
		return (
			<option key={i} value={item.id}>{item.name}</option>
		)
	}, this);

    let DropDownData =this.DDLData.optgroup;  
    let topicsvalues = Object.keys(DropDownData).map(function(key) {
        let dropdata = key
        
        return (<option key={key}  value={dropdata}>{dropdata}</option>)
       
    })

    let subtopicslist;
    if(Object.keys(this.state.subTopicsData).length > 0){
        let subtopicdata = this.state.subTopicsData;
        subtopicslist = Object.keys(subtopicdata).map(function(key) {
            let subtopicdropdata = subtopicdata[key]
            
            return (<option key={key}  value={subtopicdropdata}>{subtopicdropdata}</option>)
           
        })
    }
    
    let subCallPlanlist;
    if(this.state.callPlan.length > 0){
        console.log("Call Plan :"+ this.state.callPlan);
        let subcallplandata = this.state.callPlan;
        subCallPlanlist = Object.keys(subcallplandata).map(function(key) {
            let subcallPlandropdata = subcallplandata[key]
            
            return (<option key={key}  value={subcallPlandropdata}>{subcallPlandropdata}</option>)
           
        }) 
    }

    let CallMeTimeSlots;
    if(this.state.timeSlots.length > 0){
        let timeSlotdata = this.state.timeSlots;
        CallMeTimeSlots = Object.keys(timeSlotdata).map(function(key) {
            let timeSlotdropdata = timeSlotdata[key]
            
            return (<option key={key}  value={timeSlotdropdata}>{timeSlotdropdata}</option>)
           
        }) 
    }
      
        if (Object.keys(this.state.subTopicsData).length === 0) {
            return (
                
                <React.Fragment>
                    <div>
                        <br></br>
                    </div>
                    
                <DropdownSelect 
	label="Select a topic"
	errorText='Select a state'
	error={false}	
	readOnly={false}
	inlineLabel={false}	
    onChange={this.showSubtopicsList.bind(this)}
	>
         <option>Select</option>
        {topicsvalues}
</DropdownSelect>

</React.Fragment>
   

            )
        } else if (Object.keys(this.state.subTopicsData).length > 0 && this.state.callPlan.length === 0) {
            return (
                <React.Fragment>
                     <div>
                        <br></br>
                    </div>
                      <DropdownSelect 
	label="Select a topic"
	errorText='Select a state'
	error={false}
	disabled={false}
	readOnly={false}
	inlineLabel={false}	
    value={this.state.selecttopicValue} 
    onChange={this.showSubtopicsList.bind(this)}
	>
 {topicsvalues}
</DropdownSelect>
<div></div>
<DropdownSelect 
	label="Select a reason"
	errorText='Select a state'
	error={false}
	disabled={false}
	readOnly={false}
	inlineLabel={false}	
    onChange={this.showshowCallPlanlist.bind(this)}
	>
    <option>Select</option>
    {subtopicslist}
</DropdownSelect>
                </React.Fragment>
            )
        } else if (this.state.callPlan.length > 0 && this.state.timeSlots.length === 0) {
            return (
                <React.Fragment>
                     <div>
                        <br></br>
                    </div>
                   <DropdownSelect 
	label="Select a topic"
	errorText='Select a state'
	error={false}
	disabled={false}
	readOnly={false}
	inlineLabel={false}	
    onChange={this.showSubtopicsList.bind(this)}
	>
 {topicsvalues}
</DropdownSelect>
<div></div>
<DropdownSelect 
	label="Select a reason"
	errorText='Select a state'
	error={false}
	disabled={false}
	readOnly={false}
	inlineLabel={false}	
    onChange={this.showshowCallPlanlist.bind(this)}
	>
  {subtopicslist}
</DropdownSelect>
<div></div>
<DropdownSelect 
	label="When would you like us to call"
	errorText='Select a state'
	error={false}
	disabled={false}
	readOnly={false}
	inlineLabel={false}	
    onChange={this.showtimeSlotlist.bind(this)}
	>
          <option>Select</option>
 {subCallPlanlist}
</DropdownSelect>
                </React.Fragment>
            )
        } else if (this.state.timeSlots.length > 0) {
            return (
                <React.Fragment>
                     <div>
                        <br></br>
                    </div>
                     <DropdownSelect 
	label="Select a topic"
	errorText='Select a state'
	error={false}
	disabled={false}
	readOnly={false}
	inlineLabel={false}	
    onChange={this.showSubtopicsList.bind(this)}
	>
 {topicsvalues}
</DropdownSelect>
<div></div>
<DropdownSelect 
	label="Select a reason"
	errorText='Select a state'
	error={false}
	disabled={false}
	readOnly={false}
	inlineLabel={false}	
    onChange={this.showshowCallPlanlist.bind(this)}
	>
  {subtopicslist}
</DropdownSelect>
<div></div>
<DropdownSelect 
	label="When would you like us to call"
	errorText='Select a state'
	error={false}
	disabled={false}
	readOnly={false}
	inlineLabel={false}	
    id ="callPlanId"
    onChange={this.showtimeSlotlist.bind(this)}
	>
 {subCallPlanlist}
</DropdownSelect>
<div></div>
<DropdownSelect 
	label="What time?"
	errorText='Select a state'
	error={false}
	disabled={false}
	readOnly={false}
	inlineLabel={false}	
    onChange={this.settimeSlot.bind(this)}
	>
         <option>Select</option>
 {CallMeTimeSlots}
</DropdownSelect>
                </React.Fragment>
            )
        }
    }
}

function DropDownList(DropDownData) {
    let values = Object.keys(DropDownData.DropDownData).map(function(value) {
        return DropDownData.DropDownData[value]
    })
    if (DropDownData.isArray) {
        return (
            <div className="m_input-field multi-dropdowns" key="dropdowns">
                <label>{DropDownData.Label}</label>
                <div className={"dropdown " + DropDownData.Class} key="dropdowns" data-item-index={DropDownData.ItemIndex} tabIndex="0" onKeyDown={DropDownData.KeyAction}>
                    <div className="text" onClick={DropDownData.OnChange}> Select </div>
                    <ul key="dropdowns" className="dropdown-menu fancy-options_list" role="listbox">
                        {
                            DropDownData.DropDownData.map((item, index) => {
                                return <li aria-label={item} key={index} data-item-index={index} className="ddl-item" tabIndex="0" onClick={DropDownData.ItemSelect}>{item}</li>
                            })
                        }
                    </ul>
                </div>
            </div>
        )
    } else {
        return (
            <div className="m_input-field multi-dropdowns" key="dropdowns">
                <label>{DropDownData.Label}</label>
                <div className={"dropdown " + DropDownData.Class} key="dropdowns" data-item-index={DropDownData.ItemIndex} tabIndex="0" onKeyDown={DropDownData.KeyAction}>
                    <div className="text" onClick={DropDownData.OnChange}> Select </div>
                    <ul key="dropdowns" className="dropdown-menu fancy-options_list" role="listbox">
                        {
                            Object.keys(DropDownData.DropDownData).map((item, index) => {
                                const value = values[index];
                                return <li aria-label={item} key={index} data-item-value={value} data-item-index={index} className="ddl-item" tabIndex="0" onClick={DropDownData.ItemSelect}>{item}</li>
                            })
                        }
                    </ul>
                </div>
            </div>
        )
    }
}

function DropDownDataBinding(DropDownData){
  
let values = Object.keys(DropDownData).map(function(key) {
    let dropdata = DropDownData[key]
    return <option key={key}  value={dropdata}>{dropdata}</option>
   
})


}



// WEBPACK FOOTER //
// ./src/components/modules/DropDownCallMe.js